<template>
  <div class="tracking-funnel">
    <div class="tracking-funnel-inner">
      <svg
          :class="['tracking-funnel-graph']"
          :style="{ width: width + 'px',
                    height: height + 'px' }">
        <path
          :d="`
            ${selectedSection === 'member' ? innerCurve : middleCurve}
            H${width} L${width} ${top.end} H${hLine}
            C${top.curve2.controlPoint1.x} ${top.curve2.controlPoint1.y}
            ${top.curve2.controlPoint2.x} ${top.curve2.controlPoint2.y}
            ${top.curve2.endPoint.x} ${top.curve2.endPoint.y}
            C${top.curve1.controlPoint1.x} ${top.curve1.controlPoint1.y}
            ${top.curve1.controlPoint2.x} ${top.curve1.controlPoint2.y}
            ${top.curve1.endPoint.x} ${top.curve1.endPoint.y}
            V${selectedSection === 'member' ? inner.start : middle.start}
            Z
          `"
          :fill="!selectedSection || selectedSection === 'member' ? 'url(#selected1_linear)' : 'url(#disabled_linear)'"
        />
        <path
          class="bottom-section"
          :d="`
            ${selectedSection === 'guest' ? innerCurve : middleCurve}
            H${width} L${width} ${bottom.end} H${hLine}
            C${bottom.curve2.controlPoint1.x} ${bottom.curve2.controlPoint1.y}
            ${bottom.curve2.controlPoint2.x} ${bottom.curve2.controlPoint2.y}
            ${bottom.curve2.endPoint.x} ${bottom.curve2.endPoint.y}
            C${bottom.curve1.controlPoint1.x} ${bottom.curve1.controlPoint1.y}
            ${bottom.curve1.controlPoint2.x} ${bottom.curve1.controlPoint2.y}
            ${bottom.curve1.endPoint.x} ${bottom.curve1.endPoint.y}
            V${selectedSection === 'guest' ? inner.start : middle.start}
            Z
          `"
          :fill="!selectedSection || selectedSection === 'guest' ? 'url(#selected2_linear)' : 'url(#disabled_linear)'"
        />
        <path
          v-if="selectedSection"
          :d="`
            M0 ${middle.start}
            C${middle.curve1.controlPoint1.x} ${middle.curve1.controlPoint1.y}
            ${middle.curve1.controlPoint2.x} ${middle.curve1.controlPoint2.y}
            ${middle.curve1.endPoint.x} ${middle.curve1.endPoint.y}
            C${middle.curve2.controlPoint1.x} ${middle.curve2.controlPoint1.y}
            ${middle.curve2.controlPoint2.x} ${middle.curve2.controlPoint2.y}
            ${middle.curve2.endPoint.x} ${middle.curve2.endPoint.y}
            H${width}
            L${width} ${inner.end}
            H${hLine}
            C${inner.curve1.controlPoint1.x} ${inner.curve1.controlPoint1.y}
            ${inner.curve1.controlPoint2.x} ${inner.curve1.controlPoint2.y}
            ${inner.curve1.endPoint.x} ${inner.curve1.endPoint.y}
            C${inner.curve2.controlPoint1.x} ${inner.curve2.controlPoint1.y}
            ${inner.curve2.controlPoint2.x} ${inner.curve2.controlPoint2.y}
            ${inner.curve2.endPoint.x} ${inner.curve2.endPoint.y}
            V${middle.start}
            Z
          `"
          :fill="selectedSection === 'member' ? 'url(#unselected1_linear)' : 'url(#unselected2_linear)'"
        />
        <path
          v-show="!selectedSection || selectedSection === 'guest'"
          :d="`
            M${width} ${bottom.end}
            H${hLine}
            C${bottom.curve2.controlPoint1.x} ${bottom.curve2.controlPoint1.y}
            ${bottom.curve2.controlPoint2.x} ${bottom.curve2.controlPoint2.y}
            ${bottom.curve2.endPoint.x} ${bottom.curve2.endPoint.y}
            C${bottom.curve1.controlPoint1.x} ${bottom.curve1.controlPoint1.y}
            ${bottom.curve1.controlPoint2.x} ${bottom.curve1.controlPoint2.y}
            ${bottom.curve1.endPoint.x} ${bottom.curve1.endPoint.y}
            `"
            fill="none" :stroke-width="1" stroke="url(#shadow_linear)" />

        <defs>
          <linearGradient id="selected1_linear" x1="46" y1="33.1609" x2="-1.53076e-07" y2="33.1609" gradientUnits="userSpaceOnUse">
            <stop stop-color="#EC0047"/>
            <stop offset="1" stop-color="#EC0047" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="selected2_linear" x1="45.9687" y1="122.49" x2="-0.0312512" y2="122.49" gradientUnits="userSpaceOnUse">
            <stop stop-color="white"/>
            <stop offset="1" stop-color="white" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="unselected1_linear" x1="46" y1="26.5287" x2="-1.53076e-07" y2="26.5287" gradientUnits="userSpaceOnUse">
            <stop stop-color="#EC0047" stop-opacity="0.16"/>
            <stop offset="1" stop-color="#EC0047" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="unselected2_linear" x1="38.4941" y1="32.5665" x2="-0.0261697" y2="32.5665" gradientUnits="userSpaceOnUse">
            <stop stop-color="#BBBBBB" stop-opacity="0.3"/>
            <stop offset="1" stop-color="#BBBBBB" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="disabled_linear" x1="38.4941" y1="29.1886" x2="-0.0261697" y2="29.1886" gradientUnits="userSpaceOnUse">
            <stop stop-color="#CCCCCC"/>
            <stop offset="1" stop-color="#CCCCCC" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="shadow_linear" x1="326" y1="34.4984" x2="0" y2="34.4984" gradientUnits="userSpaceOnUse">
            <stop stop-color="#DCDCDC" stop-opacity="0"/>
            <stop offset="0.170879" stop-color="#DCDCDC"/>
            <stop offset="0.665" stop-color="#DCDCDC"/>
            <stop offset="0.97" stop-color="#DCDCDC" stop-opacity="0"/>
          </linearGradient>
        </defs>
      </svg>
      <div class="tracking-selector top">
        <ui-checkbox :value="!tracking || (tracking.type === 'member' && isTrackingAll)" :unselect="tracking && tracking.type === 'member' && !isTrackingAll" :disabled="disabledMessage.member" @input="$emit('setTracking', 'member')">
          {{ $t('tracking.member') }}
        </ui-checkbox>
        <div class="tooltip" v-if="disabledMessage.member" v-btf-tooltip="{contents: disabledMessage.member , padding: '10px 12px', offsetY: -8, textAlign: 'center'}"></div>
      </div>
      <div class="tracking-selector bottom">
        <ui-checkbox :value="!tracking || (tracking.type === 'guest' && isTrackingAll)" :unselect="tracking && tracking.type === 'guest' && !isTrackingAll" :disabled="disabledMessage.guest" @input="$emit('setTracking', 'guest')">
          {{ $t('tracking.guest') }}
        </ui-checkbox>
        <div class="tooltip" v-if="disabledMessage.guest" v-btf-tooltip="{contents: disabledMessage.guest , padding: '10px 12px', offsetY: -8, textAlign: 'center'}"></div>
      </div>
      <span v-if="!tracking || tracking.type === 'member'" v-show="!disabled" :class="['tracking-ratio member', {disabled: tracking && tracking.type !== 'member'}]" :style="{ 'top': `${getTrackingRatioPos(sessionRatio.selectedMember)}` }">{{ (sessionRatio.selectedMember * 100) | fixed(1) }}%</span>
      <span v-if="!tracking || tracking.type === 'guest'" v-show="!disabled" :class="['tracking-ratio guest', {disabled: tracking && tracking.type !== 'guest'}]" :style="{ 'bottom': `${getTrackingRatioPos(sessionRatio.selectedGuest)}` }">{{ (sessionRatio.selectedGuest * 100) | fixed(1) }}%</span>
    </div>
  </div>
</template>

<script>
import UiCheckbox from '@/components/ui/UiCheckbox'

export default {
  name: 'TrackingFunnel',
  components: {
    UiCheckbox
  },
  props: {
    isTrackingAll: {},
    tracking: {},
    overallSessionData: {},
    sessionRatio: {}
  },
  data () {
    return {
      width: 206,
      height: 140,
      hLine: 179,
      offsetY: {
        start: 70,
        end: 12,
        curve1: {
          controlPoint1: 68,
          controlPoint2: 70,
          endPoint: 70
        },
        curve2: {
          controlPoint1: 12,
          controlPoint2: 26,
          endPoint: 42
        }
      },
      x: {
        curve1: {
          controlPoint1: 71,
          controlPoint2: 28,
          endPoint: 0
        },
        curve2: {
          controlPoint1: 159,
          controlPoint2: 137,
          endPoint: 112
        }
      }
    }
  },
  computed: {
    disabled () {
      return isNaN(this.sessionRatio.allMember)
    },
    selectedSection () {
      if (this.disabled) return 'guest'
      return this.tracking && this.tracking.type
    },
    percent () {
      if (this.disabled) return 0
      return this.sessionRatio.allMember
    },
    innerPercent () {
      if (!this.tracking || this.disabled) return 0
      if (this.tracking.type === 'member') {
        return this.sessionRatio.selectedMember / this.sessionRatio.allMember
      } else {
        return this.sessionRatio.selectedGuest / this.sessionRatio.allGuest
      }
    },
    disabledMessage () {
      const tooltip = { member: null, guest: null }
      if (this.tracking && !this.isTrackingAll) {
        if (this.tracking.type === 'member') {
          tooltip.guest = this.$t('tracking.partialTracking')
        } else {
          tooltip.member = this.$t('tracking.partialTracking')
        }
      }

      if (this.sessionRatio.allMember === 1 || this.sessionRatio.allGuest === 1) {
        tooltip.member = this.$t('tracking.preventTracking')
        tooltip.guest = this.$t('tracking.preventTracking')
      }
      return tooltip
    },
    center () {
      return this.height / 2
    },
    top () {
      return this.calculateCurve(this.center, this.offsetY, this.x, -1)
    },
    bottom () {
      return this.calculateCurve(this.center, this.offsetY, this.x, 1)
    },
    middle () {
      const middleStartY = this.height * this.percent
      const middleEndY = this.center - this.offsetY.end + this.offsetY.end * 2 * this.percent

      return {
        start: middleStartY,
        end: middleEndY,
        curve1: {
          controlPoint1: this.interpolateCoords(this.top.curve1.controlPoint2, this.bottom.curve1.controlPoint2, this.percent),
          controlPoint2: this.interpolateCoords(this.top.curve1.controlPoint1, this.bottom.curve1.controlPoint1, this.percent),
          endPoint: this.interpolateCoords(this.top.curve2.endPoint, this.bottom.curve2.endPoint, this.percent)
        },
        curve2: {
          controlPoint1: this.interpolateCoords(this.top.curve2.controlPoint2, this.bottom.curve2.controlPoint2, this.percent),
          controlPoint2: this.interpolateCoords(this.top.curve2.controlPoint1, this.bottom.curve2.controlPoint1, this.percent),
          endPoint: { x: this.hLine, y: middleEndY }
        }
      }
    },
    inner () {
      if (!this.selectedSection) return null
      const base = this.selectedSection === 'member' ? this.top : this.bottom
      let innerStartY = this.interpolateValue(base.start, this.middle.start, this.innerPercent)
      let innerEndY = this.interpolateValue(base.end, this.middle.end, this.innerPercent)

      return {
        start: innerStartY,
        end: innerEndY,
        curve1: {
          controlPoint1: this.interpolateCoords(base.curve2.controlPoint1, this.middle.curve2.controlPoint2, this.innerPercent),
          controlPoint2: this.interpolateCoords(base.curve2.controlPoint2, this.middle.curve2.controlPoint1, this.innerPercent),
          endPoint: this.interpolateCoords(base.curve2.endPoint, this.middle.curve1.endPoint, this.innerPercent)
        },
        curve2: {
          controlPoint1: this.interpolateCoords(base.curve1.controlPoint1, this.middle.curve1.controlPoint2, this.innerPercent),
          controlPoint2: this.interpolateCoords(base.curve1.controlPoint2, this.middle.curve1.controlPoint1, this.innerPercent),
          endPoint: { x: 0, y: innerStartY }
        }
      }
    },
    middleCurve () {
      return `
        M0 ${this.middle.start}
        C${this.middle.curve1.controlPoint1.x} ${this.middle.curve1.controlPoint1.y}
        ${this.middle.curve1.controlPoint2.x} ${this.middle.curve1.controlPoint2.y}
        ${this.middle.curve1.endPoint.x} ${this.middle.curve1.endPoint.y}
        C${this.middle.curve2.controlPoint1.x} ${this.middle.curve2.controlPoint1.y}
        ${this.middle.curve2.controlPoint2.x} ${this.middle.curve2.controlPoint2.y}
        ${this.middle.curve2.endPoint.x} ${this.middle.curve2.endPoint.y}
      `
    },
    innerCurve () {
      return `
        M0 ${this.inner.start}
        C${this.inner.curve2.controlPoint2.x} ${this.inner.curve2.controlPoint2.y}
        ${this.inner.curve2.controlPoint1.x} ${this.inner.curve2.controlPoint1.y}
        ${this.inner.curve1.endPoint.x} ${this.inner.curve1.endPoint.y}
        C${this.inner.curve1.controlPoint2.x} ${this.inner.curve1.controlPoint2.y}
        ${this.inner.curve1.controlPoint1.x} ${this.inner.curve1.controlPoint1.y}
        ${this.hLine} ${this.inner.end}
      `
    }
  },
  methods: {
    calculateCurve (center, offsetY, x, direction) {
      return {
        start: center + direction * offsetY.start,
        end: center + direction * offsetY.end,
        curve1: {
          controlPoint1: { x: x.curve1.controlPoint1, y: center + direction * offsetY.curve1.controlPoint1 },
          controlPoint2: { x: x.curve1.controlPoint2, y: center + direction * offsetY.curve1.controlPoint2 },
          endPoint: { x: x.curve1.endPoint, y: center + direction * offsetY.curve1.endPoint }
        },
        curve2: {
          controlPoint1: { x: x.curve2.controlPoint1, y: center + direction * offsetY.curve2.controlPoint1 },
          controlPoint2: { x: x.curve2.controlPoint2, y: center + direction * offsetY.curve2.controlPoint2 },
          endPoint: { x: x.curve2.endPoint, y: center + direction * offsetY.curve2.endPoint }
        }
      }
    },
    interpolateValue (value1, value2, ratio) {
      return (value2 - value1) * ratio + value1
    },
    interpolateCoords (coord1, coord2, ratio) {
      return {
        x: this.interpolateValue(coord1.x, coord2.x, ratio),
        y: this.interpolateValue(coord1.y, coord2.y, ratio)
      }
    },
    getTrackingRatioPos (ratio) {
      return (ratio * 100) / 2 + '%'
    }
  }
}

</script>

<style lang="scss" scoped>
.tracking-funnel {
  width: 206px;
  height: 140px;

  .tracking-selector {
    position: absolute;
    left: 45px;
    .tooltip {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    /deep/ .ui_checkbox {
      margin: 0;
      .text {
        font-weight: 600;
        font-size: 12px;
        color: #666666;
      }
    }
    &.top {
      top: -13px;
      transform: translate(0, -100%);
    }
    &.bottom {
      bottom: -13px;
      transform: translate(0, 100%);
    }
  }

  .tracking-ratio {
    position: absolute;
    left: 43px;
    padding: 4px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    &.member {
      outline: 1px solid rgba(255, 255, 255, 0.32);
      background: rgba(236, 0, 71, 0.68);
      color: #FFF;
    }
    &.guest {
      outline: 1px solid rgba(0, 0, 0, 0.08);
      background: rgba(255, 255, 255, 0.56);
      color: #444;
    }
    &.disabled {
      opacity: 0.6;
      border: none;
      background: none;
      color: #FFF;
    }
  }
  stop,
  path,
  marker {
    transition: all 0.2s ease;
  }
}
</style>
